import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppComponent} from './app.component';
import {LayoutModule} from "./layout/layout.module";
import {AuthModule} from "./auth/auth.module";
import {ToastrModule} from "ngx-toastr";
import {CommonModule} from "@angular/common";
import {AUTH_INTERCEPTOR_PROVIDER} from "./core/interceptor/auth.interceptor";
import {ERROR_HANDLING_PROVIDER} from "./core/interceptor/error-handling.interceptor";
import {RecoverPasswordComponent} from './auth/recover-password/recover-password.component';
import {SharedModule} from "./shared/shared.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {ChangePasswordComponent} from './obligor-search/change-password/change-password.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatCardModule} from "@angular/material/card";
import {MatExpansionModule} from "@angular/material/expansion";
import {PrintModalComponent} from "./pro-report/print-modal/print-modal.component";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {NewsComponent} from './news/news.component';
import {NotFoundRecourseComponent} from './not-found-recource/not-found-recourse.component';
import {DirectDocMGNComponent} from "./direct-doc/direct-doc-mgn.component";
import {DirectAccessComponent} from "./direct-access/direct-access.component";
import {MatTableModule} from "@angular/material/table";
import {NgxSpinnerModule} from "ngx-spinner";

@NgModule({
  declarations: [
    AppComponent,
    RecoverPasswordComponent,
    ChangePasswordComponent,
    PrintModalComponent,
    NewsComponent,
    NotFoundRecourseComponent,
    DirectDocMGNComponent,
  ],
  imports: [
    ToastrModule.forRoot({
      positionClass: 'toastr-top-right'
    }),
    CommonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    BrowserModule,
    AppRoutingModule,
    LayoutModule,
    AuthModule,
    BrowserAnimationsModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatGridListModule,
    MatCardModule,
    MatExpansionModule,
    MatTableModule,
    NgxSpinnerModule
  ],
  providers: [
    AUTH_INTERCEPTOR_PROVIDER,
    ERROR_HANDLING_PROVIDER
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
